<template>
  <Dialog
    @maximize="state.isMaximize = true"
    @unmaximize="state.isMaximize = false"
    v-model:visible="state.cvappear"
    maximizable
    modal
    :header="`${state.dataTableClickName} CV`"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <div style="position: relative; height: 100%">
      <Skeleton
        style="
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          z-index: 9;
          width: 100% !important;
          height: 100% !important;
        "
        width="300px"
        height="300px"
        v-if="!state.onLoadView && !state.onLoadSelected"
      />
      <iframe
        class="w-100"
        v-if="state.showCV && !state.selectedCvView"
        :style="{ height: state.isMaximize ? '100%' : '500px' }"
        :src="`${cvLink + state.cvData?.[0]?.path + '#toolbar=0&navpanes=0'}`"
        frameborder="0"
        @load="state.onLoadView = true"
        ref="cvViewer"
      />
      <iframe
        class="w-100"
        v-if="state.showCV && state.selectedCvView"
        :style="{ height: state.isMaximize ? '100%' : '500px' }"
        :src="`${cvLink + state.selectedCv?.path + '#toolbar=0&navpanes=0'}`"
        frameborder="0"
        @load="state.onLoadSelected = true"
        ref="cvSelectedViewer"
      />
    </div>
  </Dialog>

  <div
    v-if="state.loadingFile"
    class="loading-overlay"
  >
    <i
      class="pi pi-spin pi-spinner loading-spinner"
    />
    <h6 style="z-index: 10; color: white">{{ $t('loadingFile') }}</h6>
  </div>
  <form
    @submit.prevent="handleLogin()"     
    autocomplete="off"
    class="p-fluid"
    style="margin-top: 15px"
  >
    <div
      class="refer-header"
      v-if="!candidateList"
    >
      <div class="title-container">
        <label
          v-if="!candidateList"
          class="title-label"
          :title="product.short_name"
        >
          {{
            product.short_name && product.short_name.length > 40
              ? `${product.short_name.slice(0, 40)}... / ${
                  product.company_name
                }`
              : `${product.short_name || ''} / ${product.company_name || ''}`
          }}
        </label>
      </div>
      <div class="action-container">
        <CButton 
          :label="!state.webpageChild ? `Refer Existing Candidate` : `New Candidate`" 
          @click="!state.webpageChild ? referNewCandidate() : referexistingCandidate()" 
          :icon="!state.webpageChild ? 'pi pi-user' : 'pi pi-plus'" 
          class="refer-button" 
        />
      </div>
    </div>
    <div class="input-panel p-d-flex p-flex-column" style="gap: 10px">
      <div v-if="state.webpageChild" class="p-inputgroup search-container">
        <div class="search-filters">
          <div class="filter-group">
            <span class="p-float-label">
          <Dropdown
                :showClear="state.selectedCountries"
            id="selectedCountries"
                v-model="state.selectedCountries"
            filter
                :options="state.countries"
            optionLabel="description"
            optionValue="id"
                class="modern-dropdown"
            @change="getCities('job')"
          />
              <label for="selectedCountries">
                {{ state.selectedCountries ? $t('country') + '*' : $t('country') }}
          </label>
            </span>
        </div>

          <div class="filter-group">
            <span class="p-float-label">
          <Dropdown
                :showClear="state.jobselectedCities"
            id="jobselectedCities"
                :loading="state.cityLoading"
                :disabled="!state.jobCities.length > 0"
                v-model="state.jobselectedCities"
            filter
                :options="state.jobCities"
            optionLabel="description"
            optionValue="id"
                class="modern-dropdown"
            :maxSelectedLabels="3"
              />
              <label for="jobselectedCities">
                {{ state.jobselectedCities ? $t('city') + '*' : $t('city') }}
          </label>
            </span>
        </div>

          <div class="filter-group search-input-container">
            <span class="p-float-label">
          <InputText
            autocomplete="keyword"
            type="text"
            id="keyword"
                v-model="state.keyword"
                class="modern-input"
                @input="getData()"
              />
              <label for="keyword">
                {{ state.keyword ? $t('keyword') + '*' : $t('keyword') }}
          </label>
            </span>
        </div>
      </div>
      </div>

    <div v-if="state.webpageChild" class="candidate-table-container">
        <div v-if="state.loading" class="list-loading">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem; color: #fc6c2a;"></i>
          <p>{{ $t('loading') || 'Loading...' }}</p>
        </div>
        
        <div v-else-if="visibleData.length === 0" class="empty-message">
          <i class="pi pi-search" style="font-size: 2rem; margin-bottom: 1rem; color: #ccc;"></i>
          <p>{{ $t('nojobsFound') }}</p>
        </div>
        
        <div v-else class="radio-list-container">
          <div 
            v-for="(item, index) in visibleData" 
            :key="index"
            class="radio-list-item"
            :class="{ 'selected': state.jobs && (state.jobs === item) }"
            @click="handleRowClick({ data: item })"
          >
            <div class="radio-item-single-line">
              <div class="radio-selector">
                <RadioButton
                  v-model="state.jobs"
                  :inputId="`radio_${index}`"
                  name="jobs"
                  :value="item"
                  :class="{ 'p-invalid': state.submitted && !state.jobs }"
                  @click="jobSelected(item)"
                />
                <template v-if="!state.candidateSearch">
                  <img
                    loading="lazy"
                    :src="logoURL + item.company_logo"
                    :alt="item.company_logo"
                    class="company-logo"
                    v-tooltip.top="item.company_name"
                  />
                  <span class="job-title" v-tooltip.top="item.short_name">{{ item.short_name }}</span>
                  <span class="detail-separator">|</span>
                  <span class="job-type" v-tooltip.top="item.job_type_name">{{ item.job_type_name }}</span>
                  <span class="detail-separator">|</span>
                  <span class="detail-text location" v-tooltip.top="item.location_country_name && item.location_city_name
                        ? item.location_country_name + '/' + item.location_city_name
                        : item.location_country_name
                        ? item.location_country_name
                        : item.location_city_name
                        ? item.location_city_name
                        : 'Not Specified'
                    ">
                    <i class="pi pi-map-marker detail-icon"></i>
                    {{
                      item.location_country_name && item.location_city_name
                        ? item.location_country_name + '/' + item.location_city_name
                        : item.location_country_name
                        ? item.location_country_name
                        : item.location_city_name
                        ? item.location_city_name
                        : 'Not Specified'
                    }}
                  </span>
                </template>
                <template v-else>
                  <span class="candidate-full-name">{{ item.firstname }} {{ item.lastname }}</span>
                  <span class="detail-separator">|</span>
                  <span class="detail-text location">
                    <i class="pi pi-map-marker detail-icon"></i>
                    {{
                      item.country_name && item.city_name
                        ? item.country_name + '/' + item.city_name
                        : item.country_name
                        ? item.country_name
                        : item.city_name
                        ? item.city_name
                        : 'Not Specified'
                    }}
                  </span>
                </template>
              </div>
              
              <div v-if="state.candidateSearch" class="cv-action">
                <CButton 
                  variant="ghost" 
                  :disabled="!item.cv_candidate_id" 
                  @click.stop="item.cv_candidate_id && displayCV(item)" 
                  :icon="`pi pi-file-pdf`" 
                  label="Display CV" 
                  iconPos="left" 
                  class="display-cv-btn" 
                />
              </div>
            </div>
          </div>
        </div>
        
        <!-- Add the custom paginator -->
        <DataTablePaginator 
          :rows="state.rowsPerPage" 
          :totalRecords="state.candidateSearch ? state.getCandidates.length : state.getJobs.length"
          :first="state.first"
          customTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
          @first-update="onPageChange"
          class="custom-paginator"
        />
      </div>

    <div v-if="!state.webpageChild" class="p-inputgroup" style="gap: 30px">
        <div class="p-float-label">
          <InputText
            autocomplete="firstname"
            type="firstname"
            id="firstname"
            v-model="v$.firstname.$model"
            :class="[
              'form-input-medium', 
              { 'p-invalid': v$.firstname.$invalid && state.submitted, 'invalid': v$.firstname.$invalid && state.submitted }
            ]"
          />
          <label
            class="form-label"
            for="firstname"
            :class="{ 'p-error': v$.firstname.$invalid && state.submitted, 'error-color': v$.firstname.$invalid && state.submitted }"
          >
            {{
            v$.firstname.$invalid && state.submitted
                ? $t('firstname') + '*'
                : $t('firstname')
            }}
          </label>
        </div>

        <div class="p-float-label">
          <InputText
            autocomplete="lastname"
            type="lastname"
            id="lastname"
            v-model="v$.lastname.$model"
            :class="[
              'form-input-medium', 
              { 'p-invalid': v$.lastname.$invalid && state.submitted, 'invalid': v$.lastname.$invalid && state.submitted }
            ]"
          />
          <label
            class="form-label"
            for="lastname"
            :class="{ 'p-error': v$.lastname.$invalid && state.submitted, 'error-color': v$.lastname.$invalid && state.submitted }"
          >
            {{
            v$.lastname.$invalid && state.submitted
                ? $t('lastname') + '*'
                : $t('lastname')
            }}
          </label>
        </div>
        <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                {{ $t('enterkeyword') }}
           </small> -->
      </div>

    <div v-if="!state.webpageChild" class="p-inputgroup" style="gap: 30px">
        <div class="p-float-label">
          <InputText
            autocomplete="mail"
            type="email"
            id="email"
            v-model="v$.email.$model"
            :class="[
              'form-input-medium', 
              { 'p-invalid': v$.email.$invalid && state.submitted, 'invalid': v$.email.$invalid && state.submitted }
            ]"
          />
          <label
            class="form-label"
            for="email"
            :class="{ 'p-error': v$.email.$invalid && state.submitted, 'error-color': v$.email.$invalid && state.submitted }"
          >
            {{
            v$.email.$invalid && state.submitted ? $t('email') + '*' : $t('email')
            }}
          </label>
        </div>
        <div class="p-float-label">
          <PhoneNumberInput
            v-model:phoneNumber="v$.mobile.$model"
            :class="{ 'has-error': (v$.mobile.$invalid && state.submitted) && !handlePhoneValidation }"
            @is-valid="handlePhoneValidation = $event"
          />
        </div>
       
      </div>

    <div v-if="!state.webpageChild" class="p-inputgroup">
        <div class="p-float-label">
          <InputText
            autocomplete="linkedin_page"
            type="text"
            placeholder="www.linkedin.com/in/...."
            id="linkedinPage"
            v-model="v$.linkedinPage.$model"
            :class="[
              'form-input-wide', 
              { 'p-invalid': v$.linkedinPage.$invalid && state.submitted, 'invalid': v$.linkedinPage.$invalid && state.submitted }
            ]"
          />
          <label
            class="form-label"
            for="linkedinPage"
            :class="{ 'p-error': v$.linkedinPage.$invalid && state.submitted, 'error-color': v$.linkedinPage.$invalid && state.submitted }"
          >
            {{
            v$.linkedinPage.$invalid && state.submitted
                ? $t('linkedinPage') + '*'
                : $t('linkedinPage')
            }}
          </label>
        </div>

        <!-- <div class="p-float-label">
              <InputText
                autocomplete="new-password"  type="mobile" id="phone" v-model="phone"
              :style="{'border-color':'#DBDBDB','border-style':'solid','border-width':'1px','border-radius':'6px','box-sizing':'border-box', 'max-width': '320px',height: '46px','padding-left':'2.5rem' }"/>
               <label  style="font-size: medium;font-weight: 400;font-size: 12px;line-height: 17px;color: #444444;" for="linkedin" >
                {{$t("aphone") }}
              </label>
          </div> -->

        <!-- <small  style="position: absolute; pointer-events: none;top: 50%;margin-top: -.5rem;font-weight: 600;font-size: 10px;line-height: 16px;color: rgba(48, 57, 82, 0.6);" >
                {{ $t('enterkeyword') }}
           </small> -->
      </div>
      <div
      v-if="isEmailRequired"
        class="p-inputgroup mb-15"
      >
        <div class="p-float-label full-width">
          <InputText
            autocomplete="email"
            type="email"
            id="email"
            v-model="v$.email.$model"
            :class="[
              'form-input', 
              { 'p-invalid': v$.email.$invalid && state.submitted, 'invalid': v$.email.$invalid && state.submitted }
            ]"
          />
          <label
            class="form-label"
            for="email"
            :class="{ 'p-error': v$.email.$invalid && state.submitted, 'error-color': v$.email.$invalid && state.submitted }"
          >
            {{
            v$.email.$invalid && state.submitted
                ? 'Email*'
                : 'Email'
            }}
          </label>
        </div>
      </div>

      <div
      v-if="isMobileRequired"
        class="p-inputgroup mb-15"
      >
        <div class="p-float-label full-width">
          <PhoneNumberInput
            v-model:phoneNumber="v$.mobile.$model"
            :class="{ 'has-error': v$.mobile.$invalid && state.submitted && !handlePhoneValidation }"
            @is-valid="handlePhoneValidation = $event"
          />
        </div>
      </div>

      <div class="p-inputgroup flex-column">
        <div class="p-float-label" v-if="state.jobs || !state.webpageChild">
          <Textarea
            type="info"
            id="info"
            v-model="state.info"
            :maxlength="512"
            class="textarea-container"
            rows="3"
            cols="30"
          />
          <label
            class="form-label"
            for="linkedin"
          >
            {{ $t('aditionalinfo') }}
          </label>
        </div>
        <small 
          v-if="state.jobs || !state.webpageChild" 
          style="color: #666; font-size: 0.875rem; margin-top: 0.25rem"
        >
          {{ state.info ? state.info.length : 0 }}/512
        </small>
      </div>

      <div class="p-inputgroup">
        <div class="topic-selection-container">
          <div class="cv-option-content">
            <div class="option-cards-horizontal">
              <div 
                :class="['option-card-horizontal', state.uploadCV === 'latestCV' && state.cvs.length > 0 ? 'selected' : '']"
                v-if="state.cvs.length !== 0 && !state.cvs[0]?.status && !state.cvLoading"
                @click="state.uploadCV = 'latestCV'"
              >
                <div class="radio-container">
                  <RadioButton
                    v-model="state.uploadCV"
                    inputId="uploadnewCV"
                    name="cv"
                    value="latestCV"
                  />
                </div>
                <div class="option-content">
                  <h4 class="m-0">{{ $t('uselatestCv') }}</h4>
                  <p>{{ $t('uselatestCvDescription') || 'Use a CV you have already uploaded to the system' }}</p>
                </div>
              </div>

              <div 
                :class="['option-card-horizontal', state.uploadCV === 'newCV' ? 'selected' : '']"
                @click="state.uploadCV = 'newCV'"
                v-if="!state.candidateSearch || (state.candidateSearch && state.jobs) && !state.cvLoading"
              >
                <div class="radio-container">
                  <RadioButton
                    v-model="state.uploadCV"
                    inputId="uploadLatestCV"
                    name="cv"
                    value="newCV"
                  />
                </div>
                <div class="option-content">
                  <h4 class="m-0">{{ $t('uploadNewCv') }}</h4>
                  <p>{{ $t('uploadNewCvDescription') || 'Upload a new CV for this candidate' }}</p>
                </div>
              </div>
            </div>
            
            <!-- CV Content Area -->
            <div class="cv-content-area" v-if="state.uploadCV">
              <!-- CV Selection Details -->
              <div v-if="state.uploadCV === 'latestCV' && (!state.candidateSearch || (state.candidateSearch && state.jobs))" class="cv-details-container">
                <div class="cv-selector">
                  <div class="cv-dropdown-container">
                    <Dropdown
                      v-model="state.selectedCv"
                      :options="state.cvs"
                      optionLabel="name"
                      placeholder="Select a CV"
                      class="cv-dropdown"
                      appendTo="body"
                      :loading="state.cvLoading"
                    >
                      <template #option="slotProps">
                        <div class="cv-option">
                          <div class="cv-icon-container">
                            <i :class="`pi ${slotProps.option?.path?.slice(-3) === 'pdf' ? 'pi-file-pdf' : 'pi-file-word'}`"></i>
                          </div>
                          <div class="cv-option-details">
                            <span class="cv-filename">{{ slotProps.option?.name || 'Unknown file' }}</span>
                            <span class="cv-filetype">{{ slotProps.option?.path?.slice(-3) === 'ocx' ? 'DOCX' : slotProps.option?.path?.slice(-3)?.toUpperCase() }}</span>
                          </div>
                        </div>
                      </template>

                      <template #value="slotValue">
                        <div v-if="slotValue.value" class="cv-selected">
                          <div class="cv-icon-container">
                            <i :class="`pi ${slotValue.value?.path?.slice(-3) === 'pdf' ? 'pi-file-pdf' : 'pi-file-word'}`"></i>
                          </div>
                          <div class="cv-option-details">
                            <span class="cv-filename">{{ slotValue.value?.name || 'Unknown file' }}</span>
                            <span class="cv-filetype">{{ slotValue.value?.path?.slice(-3) === 'ocx' ? 'DOCX' : slotValue.value?.path?.slice(-3)?.toUpperCase() }}</span>
                          </div>
                          <button 
                            v-if="state.selectedCv" 
                            type="button" 
                            class="preview-icon-btn" 
                            @click.stop=";(state.selectedCvView = true), displayCV(state.selectedCv)"
                            title="Preview CV"
                          >
                            <i class="pi pi-eye"></i>
                          </button>
                        </div>
                        <div v-else class="cv-placeholder">
                          <div v-if="state.cvLoading" class="cv-loading-indicator">
                            <i class="pi pi-spin pi-spinner"></i>
                            <span>Loading CVs...</span>
                          </div>
                          <template v-else>
                            <div class="cv-icon-container">
                              <i class="pi pi-file"></i>
                            </div>
                            <div class="cv-option-details">
                              <span class="cv-filename">{{ slotValue.placeholder }}</span>
                              <span class="cv-filetype">DOC, DOCX, PDF</span>
                            </div>
                          </template>
                        </div>
                      </template>
                    </Dropdown>
                  </div>
                </div>
              </div>
              
              <!-- Upload CV Details -->
              <div v-if="state.uploadCV === 'newCV' && (!state.candidateSearch || (state.candidateSearch && state.jobs))" class="cv-details-container">
                <div v-if="!state.previewImage" class="cv-upload-container">
                  <div 
                    class="cv-dropzone compact" 
                    :class="{ 'drag-active': state.isDragging, 'error': !state.isfileattached }"
                    @dragover.prevent="onDragOver"
                    @dragleave.prevent="onDragLeave"
                    @drop.prevent="onDrop"
                    @click="uploadEvent"
                  >
                    <div class="cv-upload-icon">
                      <i class="pi pi-cloud-upload"></i>
                    </div>
                    <div class="cv-upload-text">
                      <span class="cv-upload-title">{{ $t('addCV') || 'Add CV' }}</span>
                      <span class="cv-upload-subtitle">{{ $t('dragDropOrClick') || 'Drag & drop or click to browse' }}</span>
                      <span class="cv-upload-formats">{{ $t('supportedFormats') || 'Supported formats: DOC, DOCX, PDF' }}</span>
                    </div>
                    <input
                      ref="fileInput"
                      type="file"
                      hidden
                      accept=".doc,.docx,.pdf"
                      id="fileID"
                      @change="uploadImage($event)"
                    />
                  </div>
                </div>

                <div v-if="state.previewImage && state.fileType" class="cv-preview">
                  <div class="cv-preview-content">
                    <div class="cv-preview-icon">
                      <i :class="`pi ${state.fileType === 'pdf' ? 'pi-file-pdf' : 'pi-file-word'}`"></i>
                    </div>
                    <div class="cv-preview-details">
                      <div class="cv-preview-filename">
                        {{ state.fileName || 'Selected file' }}
                      </div>
                      <div class="cv-preview-info">
                        <span class="cv-preview-size">{{ state.fileSize + ' KB' }}</span>
                        <span class="cv-preview-type">{{ state.fileType?.toUpperCase() }}</span>
                      </div>
                    </div>
                    <div class="cv-preview-actions">
                      <button 
                        class="preview-icon-btn delete" 
                        @click.stop="clearCV()"
                        title="Remove CV"
                      >
                        <i class="pi pi-trash"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="terms">
        <div style="display: flex; align-items: baseline">
          <Checkbox
            inputId="accept1"
            name="accept1"
            value="Accept"
            v-model="v$.accept1.$model"
            style="width: 15px; height: 15px !important"
          :class="{ 'p-invalid': v$.accept1.$invalid && state.submitted }"
          />
          <label
            for="accept1"
          :class="{ 'p-error': v$.accept1.$invalid && state.submitted }"
            >{{ $t('accept') }}</label
          >

          <router-link @click="termsandcondition = !termsandcondition" to="">{{
            $t('terms')
          }}</router-link>
        </div>
        <div class="terms" style="margin-top: 0px">
          <div style="display: flex; align-items: baseline">
            <Checkbox
              inputId="accept2"
              name="accept2"
              value="Accept"
              v-model="v$.accept2.$model"
              style="width: 15px; height: 15px !important"
            :class="{ 'p-invalid': v$.accept2.$invalid && state.submitted }"
            />
            <label
              for="accept2"
            :class="{ 'p-error': v$.accept2.$invalid && state.submitted }"
              >{{ $t('accept') }}</label
            >

            <router-link @click="dataprivacy = !dataprivacy" to="">{{
              $t('personaldataprotection')
            }}</router-link>
          </div>
          <div class="info-badge">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            <span>{{ $t('inforapp') }}</span>
          </div>
        </div>
      </div>

      <div class="buttons-action">
        <CButton variant="faded" color="secondary" @click="hideDialog" label="Cancel" />
        <CButton
        :loading="state.loading"
          type="submit"
          label="Refer"
        />
      </div>
    </div>
  </form>
  <Dialog
    class="dialog"
  v-model:visible="state.termsandcondition"
    modal
    :header="$t('terms')"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <iframe
      style="margin: auto; display: block; border: 0"
    :src="cvURL + state.terms[0].path + '#toolbar=0&navpanes=0'"
      width="600"
      height="800"
    ></iframe>
  </Dialog>
  <Dialog
  v-model:visible="state.dataprivacy"
    modal
    :header="$t('personaldataprotection')"
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
  >
    <iframe
      style="margin: auto; display: block; border: 0"
    :src="cvURL + state.terms[1].path + '#toolbar=0&navpanes=0'"
      width="600"
      height="800"
    ></iframe>
  </Dialog>
</template>
<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'
import { required, email } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { post, get, refer, logoURL, cvURL } from '../api/Services'
import PhoneNumberInput from '@/components/PhoneNumberInput.vue'
import { useToast } from 'primevue/usetoast'
import DataTablePaginator from '@/components/DataTableVue/DataTablePaginator.vue'

// Props
const props = defineProps({
    candidateList: {
      type: Boolean,
    default: false
    },
    product: {
    type: Object,
    default: () => ({})
    },
    webpage: {
      type: Boolean,
    default: false
    },
    candidateRefer: {
      type: Boolean,
    default: false
  }
})

// Emits
const emit = defineEmits(['hide-dialog', 'candidateSearch', 'reload'])

// Store
const store = useStore()
const account = computed(() => store.state.account)

// Constants and UI state
const cvLink = process.env.VUE_APP_MEDIA_URL
const errorBorderColor = '#B00020'
const colorRed = { color: '#B00020' }
const handlePhoneValidation = ref(false)

// Refs
const fileInput = ref(null)
const cvViewer = ref(null)
const cvSelectedViewer = ref(null)

// Add toast
const toast = useToast()

// Reactive state
const state = reactive({
  // Data
      dataTableClickName: '',
      isPhoneNumberValid: false,
      dataMessage: '',
  onLoadView: false,
      onLoadSelected: false,
      isMaximize: false,
      selectedCv: null,
      cvs: [],
      cvLoading: false, // Add loading state for CV fetching
      selectedCvView: false,
      file: null,
  user: {
    sqlId: null,
    parameters: ''
  },
      submitted: false,
      firstname: '',
      lastname: '',
      linkedinPage: '',
      mobile: '',
      phone: '',
      email: '',
      candidateEmail: '',
      candidateMobile: '',
      info: '',
      accept1: '',
      accept2: '',
      location: '',
      keyword: '',
      jobselectedCities: null,
      selectedCountries: null,
      countries: [],
      jobCities: [],
      getJobs: [],
      loading: true,
      fileType: null,
      fileName: null,
      previewImage: null,
      jobs: null,
      fileSize: null,
      fileLoading: false,
      value1: 0,
      display: false,
      message: '',
      uyari: 'Warning',
      referObj: {},
      loadingFile: false,
      isfileattached: true,
  candidateSearch: props.candidateRefer,
  webpageChild: props.webpage,
      getCandidates: [],
      cvappear: false,
      showCV: false,
      cvData: null,
      uploadCV: 'newCV',
      candidate: null,
      rolesLookup: [],
      terms: [],
      termsandcondition: false,
      dataprivacy: false,
      doctype: null,
      termstype: null,
      isDelete: false,
  cityLoading: false,
  isDragging: false,
  
  // Add pagination state
  rowsPerPage: 4,
  first: 0,
})

// Computed properties
const isEmailRequired = computed(() => {
  return (
    (!state.candidateSearch && !props.product.email && state.webpageChild) ||
    (state.candidateSearch && state.jobs && !state.jobs.email && state.webpageChild)
  )
})

const isMobileRequired = computed(() => {
  return (
    (!state.candidateSearch && !props.product.mobile && state.webpageChild) ||
    (state.candidateSearch && state.jobs && !state.jobs.mobile && state.webpageChild)
  )
})

// Validation rules
const rules = computed(() => ({
  firstname: { required },
  lastname: { required },
  mobile: { 
    required: !state.candidateSearch && !state.webpageChild, // Sadece gerekli olduğunda kontrol et
    valid: () => state.candidateSearch || state.webpageChild || handlePhoneValidation.value // Arama modunda veya webpageChild true ise atla
  },
  email: { required, email },
  linkedinPage: { required },
  accept1: { required },
  accept2: { required }
}))

const v$ = useVuelidate(rules, state)

// Functions
const resetFile = () => {
  state.file = null
  state.fileType = null
  state.previewImage = null
  state.fileName = null
  state.fileSize = null
  state.fileLoading = false
  state.value1 = 0
}

const handleRowClick = (event) => {
  state.jobs = event.data
  jobSelected(event.data)
}

const handleValidation = (isValid) => {
  console.log("handleValidation called with isValid:", isValid);
  state.isPhoneNumberValid = isValid
}

const fetchUserRole = async () => {
      await get('Users/Role')
}

const formatDocx = async (event) => {
  let file = event.target.files[0]
      if (file) {
        let reader = new FileReader()
        reader.readAsArrayBuffer(file)
      }
}

const getCV = async () => {
  state.cvLoading = true // Set loading state when fetching CVs
  state.user.sqlId = 53
      let parameters = [
        {
          parameter_name: 'pin_cand_user_id',
          parameter_value:
        props.product.user_id ||
        state.candidate?.user_id ||
        account.value.loggeduser.id,
        },
        { parameter_name: 'pin_cand_cand_id', parameter_value: -1 },
        { parameter_name: 'pin_output_type', parameter_value: 3 },
        { parameter_name: 'piv_search_text', parameter_value: '' },
      ]
  state.user.parameters = JSON.stringify(parameters)

  try {
    const data = await post('Commons/Executer', state.user)
    if (data) {
      state.cvs = data
    }
  } catch (error) {
    console.error("Error fetching CVs:", error)
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Failed to load CVs. Please try again.',
      life: 3000,
    })
  } finally {
    state.cvLoading = false // Reset loading state after fetching
  }
}

const insertCandidate = () => {
  state.user.sqlId = 14

      let parameters = [
        {
          parameter_name: 'pin_candidate_id',
      parameter_value: state.isDelete ? state.referObj.ReferenceId : -1,
        },
        {
          parameter_name: 'piv_command_type',
      parameter_value: state.isDelete ? 'D' : 'I',
        },
        {
          parameter_name: 'pin_referrer_user_id',
      parameter_value: account.value.loggeduser?.id,
        },
        {
          parameter_name: 'pin_job_opening_id',
      parameter_value: props.product.short_name
        ? props.product.id
        : state.jobs.short_name
        ? state.jobs.id
        : state.jobs.user_id,
        },
        {
          parameter_name: 'piv_firstname',
      parameter_value: state.firstname,
        },
        {
          parameter_name: 'piv_lastname',
      parameter_value: state.lastname,
        },
        {
          parameter_name: 'piv_linkedin_page',
      parameter_value: state.linkedinPage,
        },
        {
          parameter_name: 'piv_email',
      parameter_value: state.email,
        },
        {
          parameter_name: 'piv_mobile',
      parameter_value: state.mobile,
        },
        {
          parameter_name: 'piv_additional_info',
      parameter_value: safeHTML(state.info),
        },
        { parameter_name: 'pin_is_term1_accepted', parameter_value: 1 },
        { parameter_name: 'pin_is_term2_accepted', parameter_value: 1 },
        { parameter_name: 'piv_secondary_email', parameter_value: '' },
        {
          parameter_name: 'piv_phone',
      parameter_value: state.phone ? state.phone : '',
        },
        { parameter_name: 'pin_candidate_user_id', parameter_value: -1 },
        { parameter_name: 'pin_gender_id', parameter_value: -1 },
        { parameter_name: 'piv_birth_date', parameter_value: '' },
        { parameter_name: 'pin_location_country_id', parameter_value: -1 },
        { parameter_name: 'pin_location_city_id', parameter_value: -1 },
        { parameter_name: 'piv_headline', parameter_value: '' },
        { parameter_name: 'piv_current_title', parameter_value: '' },
        { parameter_name: 'piv_current_company', parameter_value: '' },
        { parameter_name: 'pin_year_of_experince', parameter_value: -1 },
        {
          parameter_name: 'pin_year_of_experince_in_field',
          parameter_value: -1,
        },
        { parameter_name: 'pin_education_level_id', parameter_value: -1 },
        { parameter_name: 'piv_graduated_from', parameter_value: '' },
        { parameter_name: 'pin_currency_type_id', parameter_value: -1 },
        { parameter_name: 'pin_current_salary', parameter_value: -1 },
        { parameter_name: 'pin_salary_type_id', parameter_value: -1 },
        { parameter_name: 'pin_expected_salary_type_id', parameter_value: -1 },
        { parameter_name: 'pin_expected_salary', parameter_value: -1 },
        {
          parameter_name: 'pin_expected_currency_type_id',
          parameter_value: -1,
        },
      ]
  
  state.user.parameters = JSON.stringify(parameters)
  return state.user
}

const getrolesLookup = async () => {
  state.user.sqlId = 42
  let parameters = []
  state.user.parameters = JSON.stringify(parameters)

  const data = await post('Commons/Executer', state.user)
        if (data) {
    state.rolesLookup = data
  }
}

const getTerms = async () => {
  state.user.sqlId = 43
  let parameters = []
  state.user.parameters = JSON.stringify(parameters)

  const data = await post('Commons/Executer', state.user)
        if (data) {
    state.terms = data
    state.terms.map((each) => {
            if (each.path.split('.').length > 0) {
        state.termstype = each.path
                ? each.path.split('.')[1] === 'pdf'
                  ? 'PDF'
                  : 'DOC'
                : ''
            }
          })
        }
}

const displayCV = async (cv) => {
  state.user.sqlId = 53
      let parameters = [
        {
          parameter_name: 'pin_cand_user_id',
      parameter_value: cv.user_id || state.jobs.user_id,
        },
        { parameter_name: 'pin_cand_cand_id', parameter_value: -1 },
        { parameter_name: 'pin_output_type', parameter_value: 3 },
        { parameter_name: 'piv_search_text', parameter_value: '' },
      ]
  state.user.parameters = JSON.stringify(parameters)
  state.dataTableClickName =
        cv && cv.firstname && cv.lastname
          ? `${cv.firstname} ${cv.lastname}`
      : state.selectedCv && state.selectedCv.name
      ? state.selectedCv.name
          : 'Unknown Name'
  
  fetchFile()
}

const fetchFile = async () => {
  const data = await post('Commons/Executer', state.user)
        if (data) {
    state.cvappear = true
    state.doctype = false
    state.cvData = data
    if (!state.onLoadSelected && state.selectedCvView) {
      state.dataTableClickName = state.selectedCv.name
    }
    state.showCV = true
  }
}

const referNewCandidate = () => {
  console.log("referNewCandidate called");
  state.loading = true; // Set loading state while changing views
  try {
    // Reset validation state
    state.submitted = false;
    handlePhoneValidation.value = false;
    
    // Reset form fields to prevent validation errors
    state.firstname = '';
    state.lastname = '';
    state.email = '';
    state.mobile = '';
    state.linkedinPage = '';
    state.info = '';
    state.accept1 = '';
    state.accept2 = '';
    
    state.candidateSearch = true;
    state.webpageChild = true;
    setTimeout(() => {
      getData().finally(() => {
        state.loading = false;
      });
    }, 100);
  } catch (error) {
    console.error("Error in referNewCandidate:", error);
    state.loading = false;
  }
}

const referexistingCandidate = () => {
  console.log("referexistingCandidate called");
  state.loading = true; // Set loading state while changing views
  try {
    // Reset validation state
    state.submitted = false;
    handlePhoneValidation.value = false;
    
    // Reset form fields to prevent validation errors
    state.firstname = '';
    state.lastname = '';
    state.email = '';
    state.mobile = '';
    state.linkedinPage = '';
    state.info = '';
    state.accept1 = '';
    state.accept2 = '';
    
    state.candidateSearch = false;
    state.webpageChild = false;
    state.loading = false; // Reset loading immediately as we're not fetching data
  } catch (error) {
    console.error("Error in referexistingCandidate:", error);
    state.loading = false;
  }
}

const hideDialog = () => {
  emit('hide-dialog')
}

const clearCV = () => {
  state.fileType = null
  state.previewImage = null
}

const clearImage = () => {
  clearCV()
}

const uploadImage = async (e) => {
  state.value1 = 0
      const image = e.target.files[0]
  state.file = image
  state.fileType = image ? image.name.split('.').pop() : ''
  
  if (
    state.fileType === 'jpeg' ||
    state.fileType === 'jpg' ||
    state.fileType === 'png'
  ) {
    state.doctype = 'image'
    toast.add({
          severity: 'warn',
      summary: 'Warning',
          detail: 'Please upload your CV in PDF or DOC format.',
          life: 3000,
        })
        return
      }

  state.fileType.length > 1
    ? state.fileType === 'doc' || state.fileType === 'docx'
      ? (state.doctype = 'DOC')
      : state.fileType === 'pdf'
      ? (state.doctype = 'PDF')
      : (state.doctype = null)
    : (state.doctype = null)
  
  if (state.doctype === 'DOC') {
    await formatDocx(e)
  }

  state.value1 = 50
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = (e) => {
    state.previewImage = e.target.result
    state.fileName = image.name
    state.fileSize = Number(image.size / 1024).toFixed(0)
    state.fileLoading = true
    state.value1 = 100
  }
}

const uploadEvent = () => {
  state.value1 = 0
  fileInput.value.click()
}

const jobSelected = (jobs) => {
  state.cvs = []
  state.selectedCv = null
  state.candidate = jobs
  state.jobsId = jobs.short_name ? jobs.id : props.product.id
  state.firstname = jobs.firstname || props.product.firstname
  state.lastname = jobs.lastname || props.product.lastname
  state.linkedinPage = jobs.linkedin_page || props.product.linkedin_page
  state.email = jobs.email || props.product.email
  state.mobile = jobs.mobile || props.product.mobile
  getCV()
}

const handleLogin = async () => {
  state.submitted = true
  
  // Manuel validate et
  await v$.value.$validate();
  
  // Detaylı validasyon bilgisi
  console.log("Form validation state:", {
    isInvalid: v$.value.$invalid,
    candidateSearch: state.candidateSearch,
    webpageChild: state.webpageChild,
    handlePhoneValidation: handlePhoneValidation.value
  });
  
  // Eğer aday arama veya webpage child aktifse, validasyonları atla
  const skipValidation = state.candidateSearch || state.webpageChild;
  
  // Early validation checks
  if (!skipValidation && isEmailRequired.value && !state.email) {
    toast.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter a valid email address',
      life: 3000,
    })
    return
  }
      
  if (!skipValidation && isMobileRequired.value && !state.mobile) {
    toast.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter a valid phone number',
      life: 3000,
    })
    return
  }

  // Validasyon kontrolü - sadece özel modda değilse
  if (!skipValidation && v$.value.$invalid) {
    console.log("Form değerleri:", {
      firstname: state.firstname,
      lastname: state.lastname,
      email: state.email,
      mobile: state.mobile,
      accept1: state.accept1,
      accept2: state.accept2,
      linkedinPage: state.linkedinPage,
      v_mobile: v$.value.mobile
    });
    
    console.log("Validasyon hataları:", v$.value.$errors.map(error => ({
      field: error.$propertyPath,
      message: error.$message
    })));
    
    // Hataları göster
    if (v$.value.$errors.length > 0) {
      const firstError = v$.value.$errors[0];
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: `${firstError.$propertyPath}: ${firstError.$message}` || 'Please check the form for errors',
        life: 3000,
      });
    } else if (!handlePhoneValidation.value) {
      // Telefon doğrulama hatası varsa
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter a valid phone number',
        life: 3000,
      });
    }
    return
  }

  // Validate CV selection/upload
  if (state.selectedCv == null && state.uploadCV === 'latestCV') {
    toast.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please select a CV',
      life: 3000,
    })
    return
  }
    
  if (state.uploadCV === 'newCV' && (state.fileType == null || state.previewImage == null)) {
    toast.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please upload a CV',
      life: 3000,
    })
    return
  }

  if (!skipValidation && (state.accept1 === '' || state.accept2 === '')) {
    toast.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please accept the terms and conditions',
      life: 3000,
    })
    return
  }

  // All validations passed, proceed with submission
  state.isfileattached = true
  insertCandidate()
  state.loading = true
    
  try {
    const data = await post('Commons/Executer', state.user)
    
    if (!data || data.length === 0) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No data returned from the server',
        life: 3000,
      })
      return
    }

    if (data[0].status !== 0 && !state.isDelete) {
      // Candidate not found or other issue
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: data[0].message || 'Candidate not found',
        life: 3000,
      })
      return
    }
      
    // Candidate successfully found - prepare referral data
    prepareReferralData(data[0])
    
    try {
      const referData = await refer(state.referObj)
      handleReferralResponse(referData)
    } catch (error) {
      // Network or API error
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: typeof error === 'string' ? error : 'A network error occurred',
        life: 3000,
      })
        
      state.isDelete = true
      setTimeout(() => {
        emit('hide-dialog')
      }, 2000)
    }
  } catch (error) {
    // Handle request error
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Error connecting to the server',
      life: 3000,
    })
  } finally {
    state.loading = false
  }
}

// Helper function to prepare referral data
const prepareReferralData = (data) => {
  state.referObj.ReferenceId = data.candidate_id
  state.referObj.CreateUser = account.value.loggeduser.id
  state.referObj.FileTypeId = 5
  state.referObj.Description = !props.webpage
    ? 'Candidate CV for Job #' + props.product.id
    : 'Candidate CV for Job #' + data.candidate_user_id
  state.referObj.file = state.previewImage
  state.referObj.firstname = state.firstname
  state.referObj.lastname = state.lastname
  state.referObj.company_name = props.product.company_name
  state.uploadCV === 'newCV'
    ? (state.referObj.File = state.file)
    : (state.referObj.SourceFileId = state.selectedCv?.id)
  state.referObj.CreateDate = new Date().toISOString()
  state.dataMessage = data.message
}

// Helper function to handle referral response
const handleReferralResponse = (referData) => {
  switch (referData.status) {
    case 0:
      // Success - status 0
      toast.add({
        severity: 'success',
        summary: 'Success',
        detail: state.dataMessage || referData.message || 'Candidate successfully referred',
        life: 3000,
      })
      
      emit('reload')
      emit('hide-dialog')
      break
      
    case -1:
      // Failed - status -1 - Already referred
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: referData.message || 'Candidate Already Referred to this Job',
        life: 3000,
      })
      break
      
    case -2:
      // Failed - status -2 - Name/surname not found
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: referData.message || 'Candidate name or surname not found',
        life: 3000,
      })
      
      state.isDelete = true
      break
      
    default:
      // Other error cases
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: referData.message || 'An error occurred',
        life: 3000,
      })
      emit('hide-dialog')
  }
}

const getCities = async (value) => {
  state.cityLoading = true
  state.jobCities = []

  const data = await get('/Cities/')
  if (data && value === 'job') {
    state.jobCities = data.filter(
      (each) => each.countryId == state.selectedCountries
    )
  }
}

const getData = async () => {
  console.log("getData called, candidateSearch:", state.candidateSearch);
  state.loading = true;
  
  try {
    if (state.candidateSearch) {
      state.user.sqlId = 70
        let parameters = [
          { parameter_name: 'piv_company_id', parameter_value: '' },
          { parameter_name: 'piv_job_id', parameter_value: '' },
          { parameter_name: 'piv_candidate_user_id', parameter_value: '' },
          {
            parameter_name: 'piv_search_text',
          parameter_value: state.keyword ? state.keyword : '',
          },
          { parameter_name: 'piv_first_name', parameter_value: '' },
          { parameter_name: 'piv_last_name', parameter_value: '' },
          {
            parameter_name: 'piv_country_id',
          parameter_value: state.selectedCountries
            ? state.selectedCountries
              : -1,
          },
          {
            parameter_name: 'piv_city_id',
          parameter_value: state.jobselectedCities
            ? state.jobselectedCities
              : -1,
          },
          { parameter_name: 'piv_company_responsibles', parameter_value: '' },
          { parameter_name: 'pin_referrable', parameter_value: 1 },
          { parameter_name: 'piv_internal_recruiters', parameter_value: '' },
          { parameter_name: 'piv_referrer_user_id', parameter_value: '' },
          { parameter_name: 'piv_is_accepted_by_company', parameter_value: '' },
          { parameter_name: 'piv_is_accepted', parameter_value: '' },
          { parameter_name: 'piv_candidate_stage_id', parameter_value: '' },
          { parameter_name: 'piv_candidate_status_id', parameter_value: '' },
          { parameter_name: 'piv_candidate_progress_id', parameter_value: '' },
          { parameter_name: 'piv_job_country_id', parameter_value: '' },
          { parameter_name: 'piv_job_city_id', parameter_value: '' },
          { parameter_name: 'piv_job_status_id', parameter_value: '' },
          { parameter_name: 'piv_record_type', parameter_value: 'S1' },
        ]
      state.user.parameters = JSON.stringify(parameters)
      console.log("Fetching candidates with parameters:", parameters);

      try {
        const data = await post('Commons/Executer', state.user)
            if (data) {
          state.getCandidates = data
        } else {
          // Handle empty data case
          state.getCandidates = []
        }
      } catch (error) {
        state.getCandidates = []
        toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load candidates. Please try again.',
          life: 3000,
        })
      }
      } else {
      state.user.sqlId = 3
        let parameters = [
          { parameter_name: 'pin_job_opening_id', parameter_value: -1 },
          {
            parameter_name: 'pin_city_id',
          parameter_value: state.jobselectedCities
            ? state.jobselectedCities
              : -1,
          },
          {
            parameter_name: 'pin_country_id',
          parameter_value: state.selectedCountries
            ? state.selectedCountries
              : -1,
          },
          { parameter_name: 'pin_company_id', parameter_value: -1 },
          { parameter_name: 'pin_status_id', parameter_value: 1 },
          {
            parameter_name: 'pin_assigned_company_user_id',
            parameter_value: -1,
          },
          {
            parameter_name: 'pin_assigned_internal_user_id',
            parameter_value: -1,
          },
          {
            parameter_name: 'piv_search_text',
          parameter_value: state.keyword ? state.keyword : '',
          },
          { parameter_name: 'pin_recruitment_type_id', parameter_value: -1 },
          { parameter_name: 'pin_job_type_id', parameter_value: -1 },
          { parameter_name: 'pin_is_remote', parameter_value: -1 },
          { parameter_name: 'piv_posted_after_date', parameter_value: '' },
        ]
      state.user.parameters = JSON.stringify(parameters)
      console.log("Fetching jobs with parameters:", parameters);

      try {
        const data = await post('Commons/Executer', state.user)
        console.log("Jobs API response:", data);
            if (data) {
          state.getJobs = data

        } else {
          // Handle empty data case
          state.getJobs = []
          console.log("No jobs data returned from API");
        }
      } catch (error) {
        console.error("Error fetching jobs:", error);
        state.getJobs = []
        toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load jobs. Please try again.',
          life: 3000,
        })
      }
    }
  } catch (error) {
    console.error("General error in getData:", error);
    toast.add({
      severity: 'error',
      summary: 'Error',
      detail: 'An unexpected error occurred. Please try again.',
      life: 3000,
    })
  } finally {
    console.log("getData completed, setting loading to false");
    state.loading = false
  }
}

const safeHTML = (html) => {
  if (!html) return ''
      const map = {
        '"': '&quot;',
        "'": '&#39;',
      }
  return html.replace(/["']/g, (m) => map[m])
}

// Watch effects
watch(() => state.jobCities, (newValue) => {
  if (newValue.length > 0) {
    state.cityLoading = false
  } else {
    setTimeout(() => {
      state.cityLoading = false
    }, 5000)
  }
})

watch(() => state.cvappear, (newValue) => {
  if (!newValue) {
    state.showCV = false
    state.onLoadView = false
    state.onLoadSelected = false
    state.selectedCvView = false
  }
})

watch(() => state.cvs, (newValue) => {
  if (newValue.length > 0) {
    state.uploadCV = 'latestCV'
  }
})

watch(() => state.candidateSearch, async (newValue) => {
  emit('candidateSearch', newValue)
  resetFile()
  if (newValue && props.product.user_id) {
    await getCV()
  }
  if (!newValue && !state.webpageChild) {
    state.firstname = ''
    state.lastname = ''
    state.linkedinPage = ''
    state.mobile = ''
    state.phone = ''
    state.email = ''
    state.info = ''
    v$.value.$reset()
    state.cvs = []
    state.jobs = null
    state.uploadCV = "newCV"

  }
  if (newValue) {
    getData()
  }
})

watch(() => state.isDelete, (newValue) => {
  if (newValue) {
    insertCandidate()
    post('Commons/Executer', state.user)
  }
})

watch(() => state.selectedCountries, (newValue) => {
  state.jobselectedCities = null
  getData() // Trigger search when country changes
})

// Also watch for city changes to trigger search
watch(() => state.jobselectedCities, () => {
  getData() // Trigger search when city changes
}, { immediate: false })

// Lifecycle hooks
onMounted(async () => {
  // Initialize user object structure
  state.user = {
    sqlId: null,
    parameters: ''
  }
  
  getrolesLookup()
  getTerms()
  
  // Immediately get data if candidateRefer is true
  if (props.candidateRefer && props.webpage) {
    state.candidateSearch = true
    state.webpageChild = true
    
    // Set a small delay to ensure component is fully mounted
    setTimeout(() => {
      getData()
    }, 100)
  }
})

// Add a watch for candidateRefer prop changes
watch(() => props.candidateRefer, (newValue) => {
  if (newValue && props.webpage) {
    state.loading = true; // Set loading state
    state.candidateSearch = true;
    state.webpageChild = true;
    setTimeout(() => {
      getData().finally(() => {
        state.loading = false;
      });
    }, 100);
  }
}, { immediate: true })

// Initial setup
fetchUserRole()
get('/Countries').then((data) => {
  if (data) {
    state.countries = data
  }
})
if (props.product.user_id) {
  getCV()
}
if (!state.candidateSearch) {
  getData()
}

// Drag and drop handlers
const onDragOver = (e) => {
  e.preventDefault()
  state.isDragging = true
}

const onDragLeave = () => {
  state.isDragging = false
}

const onDrop = (e) => {
  e.preventDefault()
  state.isDragging = false
  
  if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
    const file = e.dataTransfer.files[0]
    const fileType = file.name.split('.').pop().toLowerCase()
    
    // Check if file type is valid
    if (fileType === 'pdf' || fileType === 'doc' || fileType === 'docx') {
      // Create a fake event object to pass to the existing uploadImage function
      const fakeEvent = { target: { files: [file] } }
      uploadImage(fakeEvent)
    } else {
      toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please upload your CV in PDF or DOC format.',
        life: 3000,
      })
    }
  }
}

// Add pagination method
const onPageChange = (newFirst) => {
  state.first = newFirst;
}

// Compute visible data based on pagination
const visibleData = computed(() => {
  const data = state.candidateSearch ? state.getCandidates : state.getJobs;
  if (!data || data.length === 0) return [];
  
  const start = state.first;
  const end = Math.min(start + state.rowsPerPage, data.length);
  return data.slice(start, end);
});

// Watch for data changes to reset pagination when needed
watch([() => state.getCandidates, () => state.getJobs, () => state.candidateSearch], () => {
  // Reset to first page when data or search type changes
  state.first = 0;
});

// Add this function after handleValidation
const handleCandidateMobileValidation = (isValid) => {
  state.isCandidateMobileValid = isValid
}
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

// Define variables first
$error-color: #B00020;

// Common form styles
.form-input {
  border-color: #DBDBDB;
  border-style: solid;
  border-width: 1px;
  border-radius: 6px !important;
  box-sizing: border-box;
  box-shadow: none;
  
  &.invalid {
    border-color: $error-color;
  }
}

.form-input-wide {
  @extend .form-input;
  max-width: 652.5px;
}

.form-input-medium {
  @extend .form-input;
  max-width: 320px;
}

.form-label {
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #444444;
  
  &.invalid {
    color: $error-color;
  }
}

.title-label {
  font-family: 'Jost';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 23px;
  color: #103660;
}

.textarea-container {
  border-color: #DBDBDB;
  border-style: solid;
  border-width: 1px;
  border-radius: 6px;
  box-sizing: border-box;
}

.loading-overlay {
  text-align: center;
  background: rgba(128, 128, 128, 0.75);
  position: fixed;
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
}

.loading-spinner {
  z-index: 11;
  margin-top: 15vw;
  font-size: xxx-large;
  color: #fc6c2a;
}

.error-color {
  color: $error-color;
}

// Existing styles
.terms {
  width: 100%;
  line-height: 24px;
  text-align: center;
  color: rgba(48, 57, 82, 0.71);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;

  label {
    margin: auto 0;
    padding-inline-start: 4px;
    transform: translateY(12%);
  }

  a {
    color: $text-link;
    transform: translateY(12%);
    margin-left: 0.5em;
  }
}

.product-image {
  // width: 150px;
  // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23)
  width: 85px;
  height: 25px;
  margin-left: 0.5rem;
}

.upload-container {
  width: 100%;

  .upload-card {
    border-width: 2px;
    border-style: dashed;
    border-color: #c2c2c2;
    border-radius: 14px;
    padding: 19px 26px;
    background-color: #f5f5f5;
    transition: all 0.2s ease;
    
    &.drag-over {
      background-color: rgba(252, 108, 42, 0.05);
      border-color: #fc6c2a;
      box-shadow: 0 0 0 2px rgba(252, 108, 42, 0.1);
    }

    .drop_box {
      display: flex;
      cursor: pointer;
      gap: 13px;

      .upload-text {
        display: flex;
        flex-direction: column;

        span:first-child {
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 23px;
          color: #444444;
        }

        span:last-child {
          font-weight: 600;
          font-size: 16px;
          line-height: 23px;
          color: rgba(68, 68, 68, 0.5);
        }
      }
    }
  }
}

::v-deep(.p-progressbar .p-progressbar-value) {
  background: #fc6c2a !important;
}

::v-deep(.p-paginator-bottom) {
  margin-top: 0px !important;
}

::v-deep(.p-dialog-content) {
  padding: 2rem 2rem 2rem 2rem;
  margin: auto;
  width: fit-content;
}

::v-deep(.p-dialog .p-dialog-header) {
  background-color: #fc6c2a;
  padding: 10px 1.25rem 10px 1.25rem !important;
}

::v-deep(.p-checkbox-box) {
  width: 15px !important;
  height: 15px !important;
}

label {
  margin-bottom: 0px;
  cursor: pointer;
}

::v-deep(.p-placeholder) {
  opacity: 1 !important;
}

::v-deep(.upload-container .p-dropdown-label.p-inputtext) {
  padding: 0 !important;
}

/* we will explain what these classes do next! */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.buttons-action {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.button-refer {
  &:not(.carousel-button) {
    width: 124px;
    height: 42px;
  }
  background-color: #fc6c2a !important;
  color: white;
  border: 1px solid #fc6c2a;
  transition: all 0.3s ease-in-out;

  &:disabled {
    opacity: 0.5;
    user-select: none;
    background-color: #fc6c2a !important;
    color: white !important;
    border: 1px solid #fc6c2a !important;
  }

  &:hover {
    background-color: white !important;
    color: #fc6c2a;
    border: 1px solid #fc6c2a;
  }
}

.button-cancel {
  &:not(.carousel-button) {
    width: 124px;
    height: 42px;
  }

  &:disabled {
    background-color: #fff !important;
    color: #fc6c2a !important;
    border: 1px solid #fc6c2a !important;
    opacity: 0.5;
    user-select: none;
  }

  background-color: #fff !important;
  color: #fc6c2a;
  border: 1px solid #fc6c2a;
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: #fc6c2a !important;
    color: #fff;
    border: 1px solid #fff;
  }
}

.info-badge {
  display: flex;
  align-items: center;
  margin-top: 8px;
  padding: 10px 14px;
  background-color: #e9f5fe;
  border-radius: 6px;
  border-left: 4px solid #015cac;
  width: 100%;

  .pi-info-circle {
    font-size: 16px;
    color: #015cac;
    margin-right: 10px;
  }

  span {
    font-size: 14px;
    line-height: 1.5;
    color: #444444;
  }
}

// Modern search filters
.search-container {
  margin-bottom: 0.75rem;
}

.search-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  width: 100%;
  margin-bottom: 0.5rem;
}

.filter-group {
  flex: 1;
  min-width: 150px;
  position: relative;
}

.search-input-container {
  display: flex;
  align-items: flex-start;
  
  .modern-input {
    flex: 1;
  }
}

.modern-dropdown, 
.modern-input {
  width: 100%;
  border-radius: 6px;
  transition: all 0.3s ease;
  border: 1px solid #e0e0e0;
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
  height: 36px;
  
  &:hover, &:focus {
    border-color: #fc6c2a;
    box-shadow: 0 0 0 1px rgba(252, 108, 42, 0.1);
  }
}

// Make table more compact
.candidate-table-container {
  margin-bottom: 1rem;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.03);
}

.modern-table {
  border-radius: 8px;
  
  ::v-deep(.p-datatable-wrapper) {
    border-radius: 8px;
    overflow: hidden;
  }
  
  ::v-deep(.p-datatable-header) {
    background: #fff;
    padding: 0.75rem;
    border-bottom: 1px solid #f0f0f0;
  }
  
  ::v-deep(.p-paginator) {
    background: transparent;
    border: none;
    padding: 0.25rem 0;
    display: flex;
    justify-content: center;
    margin-top: 0.5rem;
    
    .p-paginator-element {
      width: 1.8rem !important;
      height: 1.8rem !important;
      margin: 0 0.15rem !important;
      min-width: 1.8rem !important;
      font-size: 0.8rem !important;
      
      &.p-highlight {
        background-color: #fc6c2a !important;
        color: white !important;
        border-color: #fc6c2a !important;
      }
    }
    
    .p-paginator-pages {
      margin: 0 !important;
      
      .p-paginator-page {
        min-width: 1.8rem !important;
        height: 1.8rem !important;
        
        &.p-highlight {
          background-color: #fc6c2a !important;
          color: white !important;
          border-color: #fc6c2a !important;
        }
      }
    }
    
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-next,
    .p-paginator-last {
      color: #666;
      font-size: 0.8rem !important;
    }
  }
  
  ::v-deep(.p-datatable-tbody > tr) {
    transition: background-color 0.2s ease;
    
    &:hover {
      background-color: rgba(252, 108, 42, 0.03);
    }
  }
  
  ::v-deep(.p-datatable-tbody > tr > td) {
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid #f8f8f8;
  }
}

.modern-header {
  color: #444 !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 0.5rem 0.75rem !important;
}

.modern-body {
  color: #333;
  font-size: 0.875rem;
}

.flex-row {
  display: flex;
  align-items: center;
}

.align-center {
  align-items: center;
}

.company-logo {
  max-width: 70px;
  width: 100%;
  height: 20px;
  object-fit: contain;
}

.candidate-name,
.candidate-lastname {
  font-weight: 500;
  margin-left: 0.5rem;
  font-size: 0.9rem;
  color: #333;
}

.location-info,
.job-type,
.location-text {
  color: #555;
  font-size: 0.875rem;
}

.cv-button {
  background-color: #f5f5f5;
  color: #333;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 0.3rem 0.75rem;
  font-weight: 500;
  font-size: 0.8rem;
  transition: all 0.2s ease;
  
  .pi {
    font-size: 0.9rem;
    margin-right: 0.25rem !important;
  }
  
  &:enabled:hover {
    background-color: #fc6c2a;
    color: white;
    border-color: #fc6c2a;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.empty-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  color: #666;
  font-size: 0.85rem;
  
  i {
    font-size: 1.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  
  p {
    margin: 0;
    font-size: 0.8rem;
  }
}

::v-deep(.p-dropdown) {
  .p-dropdown-label {
    padding-top: 0.3rem;
    padding-bottom: 0.3rem;
  }
  
  .p-dropdown-trigger {
    width: 2rem;
  }
}

::v-deep(.minimal-paginator) {
  padding: 0.25rem !important;
  border-top: none !important;
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;

  .p-paginator-element {
    width: 1.5rem !important;
    height: 1.5rem !important;
    margin: 0 0.1rem !important;
    min-width: 1.5rem !important;
    font-size: 0.7rem !important;
    
    &.p-highlight {
      background-color: #fc6c2a !important;
      color: white !important;
      border-color: #fc6c2a !important;
    }
  }
  
  .p-paginator-pages {
    margin: 0 !important;
    
    .p-paginator-page {
      min-width: 1.5rem !important;
      height: 1.5rem !important;
      
      &.p-highlight {
        background-color: #fc6c2a !important;
        color: white !important;
        border-color: #fc6c2a !important;
      }
    }
  }
  
  .p-paginator-first,
  .p-paginator-prev,
  .p-paginator-next,
  .p-paginator-last {
    color: #666;
    font-size: 0.7rem !important;
  }
}

.custom-paginator {
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
  
  ::v-deep(.p-paginator) {
    background: transparent;
    border: none;
    padding: 0.25rem;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-next,
    .p-paginator-last,
    .p-paginator-page {
      width: 2.2rem;
      height: 2.2rem;
      margin: 0 0.15rem;
      min-width: 2.2rem;
      border-radius: 6px;
      font-size: 0.8rem;
      font-weight: 500;
      
      &.p-highlight {
        background-color: #fc6c2a;
        color: white;
        border-color: #fc6c2a;
        box-shadow: 0 2px 4px rgba(252, 108, 42, 0.25);
      }
      
      &:not(.p-highlight):not(.p-disabled):hover {
        background-color: #fff2eb;
        color: #fc6c2a;
      }
    }
  }
  
  @media (max-width: 576px) {
    margin-top: 0.5rem;
    
    ::v-deep(.p-paginator) {
      padding: 0.15rem;
      
      .p-paginator-first,
      .p-paginator-prev,
      .p-paginator-next,
      .p-paginator-last,
      .p-paginator-page {
        width: 1.8rem;
        height: 1.8rem;
        min-width: 1.8rem;
        font-size: 0.7rem;
      }
    }
  }
}

.topic-selection-container {
  width: 100%;
  max-height: 150px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.cv-option-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 0.5rem;
}

.option-cards-horizontal {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  width: 100%;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.option-card-horizontal {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  background: white;
  flex: 1;
  
  &:hover {
    border-color: #ddd;
    background-color: #fafafa;
  }
  
  &.selected {
    background-color: #ebf5ff;
    border-color: #cce3ff;
  }
}

.radio-container {
  margin-right: 0.75rem;
}

.option-content {
  flex: 1;
  
  h4 {
    font-size: 0.9rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.2rem;
  }
  
  p {
    font-size: 0.8rem;
    color: #666;
    margin: 0;
    line-height: 1.3;
  }
}

.cv-content-area {
  padding: 0;
  flex: 1;
  transition: height 0.3s ease;
  height: auto;
  max-height: 80px;
}

.cv-details-container {
  width: 100%;
  border: 2px dashed #eaeaea;
  border-radius: 8px;
  background-color: transparent;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:empty {
    display: none;
  }
}

.cv-upload-container {
  width: 100%;
  height: 100%;
}

.cv-dropzone {
  &.compact {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: .75rem;
    background-color: transparent;
    cursor: pointer;
    
    .cv-upload-icon {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #ffebcc;
      margin-right: 1rem;
      
      i {
        font-size: 1.3rem;
        color: #fc6c2a;
      }
    }
    
    .cv-upload-text {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.25rem;
    }
    
    .cv-upload-title {
      font-weight: 600;
      font-size: 1rem;
      color: #333;
      line-height: 1.2;
    }
    
    .cv-upload-subtitle {
      font-size: 0.85rem;
      color: #666;
      line-height: 1.2;
    }
    
    .cv-upload-formats {
      font-size: 0.75rem;
      color: #888;
    }
  }
  
  &:hover {
    .cv-upload-icon {
      background-color: #ffe0b3;
    }
  }
  
  &.drag-active {
    border-color: #fc6c2a;
    background-color: rgba(252, 108, 42, 0.03);
  }
  
  &.error {
    border-color: #B00020;
  }
}

.cv-selector {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.cv-dropdown-container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cv-dropdown {
  width: 100% !important;
}
.cv-dropdown-container {
 ::v-deep(.p-dropdown) {
  border-radius: 8px;
  overflow: hidden;
  background-color: transparent !important;
  border: none !important;
  margin: auto  !important;
  
  .p-dropdown-label {
    padding: 0.75rem;
    display: flex;
    align-items: center;
  }
  
  .p-dropdown-trigger {
    width: 2.5rem;
    background-color: transparent;
    
    .p-dropdown-trigger-icon {
      color: #666;
      font-size: 0.9rem;
    }
  }
}
}


.cv-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.cv-selected, 
.cv-placeholder {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.cv-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background-color: #ffebcc;
  
  i {
    font-size: 1rem;
    color: #fc6c2a;
  }
}

.cv-option-details {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 100px);
}

.cv-filename {
  font-weight: 500;
  font-size: 0.9rem;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cv-filetype {
  font-weight: 500;
  font-size: 0.75rem;
  color: #777;
  text-transform: uppercase;
}

.preview-icon-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  border: none;
  background-color: #f0f7ff;
  color: #4a88dc;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  margin-left: 8px;
  
  i {
    font-size: 0.9rem;
  }
  
  &:hover {
    background-color: #fc6c2a;
    color: white;
  }
  
  &.delete {
    background-color: #fff5f5;
    color: #dc4a4a;
    
    &:hover {
      background-color: #dc4a4a;
      color: white;
    }
  }
}

.cv-preview {
  height: 100%;
  display: flex;
  width: 100%;
  align-items: center;
  padding: .75rem;
}

.cv-preview-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
}

.cv-preview-icon {
  width: 48px;
  height: 48px;
  min-width: 48px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffebcc;
  
  i {
    font-size: 1.25rem;
    color: #fc6c2a;
  }
}

.cv-preview-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-width: calc(100% - 110px);
}

.cv-preview-filename {
  font-weight: 500;
  font-size: 0.9rem;
  color: #333;
  line-height: 1.1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cv-preview-info {
  display: flex;
  gap: 0.75rem;
}

.cv-preview-size,
.cv-preview-type {
  font-size: 0.75rem;
  color: #777;
}

.cv-loading-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #fc6c2a;
  font-size: 0.85rem;
  width: 100%;
  
  i {
    font-size: 1.25rem;
  }
  
  span {
    font-weight: 500;
  }
}

.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 150px;
}

.job-name.truncate-text {
  max-width: 150px;
}

.location-text.truncate-text,
.location-info.truncate-text {
  max-width: 150px;
}

.job-type.truncate-text {
  max-width: 120px;
}

.candidate-name.truncate-text,
.candidate-lastname.truncate-text {
  max-width: 120px;
}

.full-width {
  width: 100%;
}

.mb-15 {
  margin-bottom: 15px;
}

.flex-space-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .truncate-text {
    max-width: 100px;
  }
  
  .job-name.truncate-text {
    max-width: 100px;
  }
  
  .location-text.truncate-text,
  .location-info.truncate-text {
    max-width: 100px;
  }
}

@media (max-width: 576px) {
  .truncate-text {
    max-width: 80px;
  }
  
  .job-name.truncate-text {
    max-width: 80px;
  }
  
  .location-text.truncate-text,
  .location-info.truncate-text {
    max-width: 80px;
  }
}

/* Radio Button List Styles */
.list-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  
  p {
    margin-top: 0.75rem;
    color: #666;
    font-size: 0.875rem;
  }
}

.radio-list-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.radio-list-item {
  background: white;
  border-radius: 8px;
  border: 1px solid #eaeaea;
  padding: 0.75rem 1rem;
  transition: all 0.2s ease;
  cursor: pointer;
  
  &:hover {
    border-color: #ddd;
    background-color: #fafafa;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }
  
  &.selected {
    background-color: #fff5eb;
    border-color: #fc6c2a;
  }
}

.radio-item-single-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.radio-selector {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
}

.job-title, .candidate-full-name {
  font-weight: 600;
  color: #333;
  font-size: 0.95rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
  width: 100%;
}

.detail-separator {
  color: #ccc;
  margin: 0 0.5rem;
}

.detail-icon {
  color: #666;
  font-size: 0.85rem;
  margin-right: 0.25rem;
}

.detail-text {
  color: #555;
  font-size: 0.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  
  &.job-type {
    max-width: 100px;
  }
  
  &.location {
    max-width: 200px;
  }
}

.cv-action {
  .display-cv-btn {
    background-color: #f5f5f5;
    border-color: #e0e0e0;
    color: #333;
    font-size: 0.8rem;
    padding: 0.35rem 0.65rem;
    transition: all 0.2s ease;
    white-space: nowrap;
    
    &:enabled:hover {
      background-color: #fc6c2a;
      color: white;
      border-color: #fc6c2a;
    }
    
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
    
    .pi {
      font-size: 0.85rem;
      margin-right: 0.25rem;
    }
  }
}

@media (max-width: 992px) {
  .job-title, .candidate-full-name {
    max-width: 150px;
  }
  
  .detail-text {
    &.job-type {
      max-width: 80px;
    }
    
    &.location {
      max-width: 150px;
    }
  }
}

@media (max-width: 768px) {
  .radio-item-single-line {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
  
  .radio-selector {
    flex-wrap: wrap;
    gap: 0.5rem 0.75rem;
  }
  
  .detail-separator {
    display: none;
  }
  
  .job-title, .candidate-full-name {
    width: calc(100% - 30px);
    max-width: none;
  }
  
  .detail-text {
    width: auto;
    
    &.job-type, &.location {
      max-width: none;
    }
  }
  
  .cv-action {
    width: 100%;
    
    .display-cv-btn {
      width: 100%;
    }
  }
}

@media (max-width: 576px) {
  .radio-list-item {
    padding: 0.6rem 0.75rem;
  }
}

/* Yeni responsive header tasarımı */
.refer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 12px;
}

.title-container {
  flex: 1;
  min-width: 0; /* Önemli: text-overflow için gerekli */
}

.title-label {
  font-size: 1rem;
  font-weight: 600;
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-container {
  flex-shrink: 0;
}

.refer-button {
  white-space: nowrap;
}

/* Mobil görünüm için */
@media (max-width: 768px) {
  .refer-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .title-container, .action-container {
    width: 100%;
  }
  
  .refer-button {
    width: 100%;
  }
}
</style>

